import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'

export default function Extensions() {
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [extensions, setExtensions] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 20;
    const totalPages = Math.ceil(extensions.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = extensions.slice(indexOfFirstRow, indexOfLastRow)
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'
    
      useEffect(()=>{
      const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
      }
      getCredentials()
    
      },[])



    useEffect(() => {

    const user = localStorage.getItem('definiteagent'); // Retrieve email
    if (user) {
        
        setAgent(user)
    } else {
    
    }
    }, []);

    useEffect(()=>{
        const getAgentcode =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentcode(data.OID)   

        }
        if(agent && isAuth){
            getAgentcode()
        }
    },[agent,isAuth])

    useEffect(()=>{
        const getExtensions =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getExtensions?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setExtensions(data)
        }

        if(agentCode){
            getExtensions()
        }

    },[agentCode])


    function formateDateISO(input){
        if(typeof input === 'string'){
            return input.split('T')[0]
        }
        else if (input instanceof Date){
            return input.toISOString().split('T')[0]
        }

        throw new Error('Invalid input: Expected ISO String or Date Object')
    }

    function formatter(amount) {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }



  return (
    <div>
         <div className="page-content">
             <ToastContainer />
            <Breadcrumbs title="Definite Assurance" breadcrumbItem="Extension management" />
            <Card className="mini-stats-wid">
                <CardBody>
                  
                      <div className="table-responsive">


                    <Table striped bordered hover>
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">Note No#</th>
                        <th scope="col">Policy No.</th>
                        <th scope="col">Date Done</th>
                        <th scope="col">Client</th>
                        <th scope="col">Product</th>
                        <th scope="col">Registration</th>
                        <th scope="col">Commencement Date</th>
                        <th scope="col">Expiry Date</th>
                        <th scope="col">Gross Premium(KES)</th>
                        <th scope="col">Net Commission(KES)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPolicies.map((val, index) => {
                        // Calculate the correct index based on current page
                        const globalIndex = indexOfFirstRow + index;
                        return (
                            <tr key={val.OID}>
                            <td>{globalIndex + 1}</td>
                            <td ><button className="tableButton" value={val.OID} >{val.DocumentNo}</button></td>
                            <td >{val.PolicyNo}</td>
                            <td>{formateDateISO(val.DateDone)}</td>
                            
                            <td>{val.Dealer_name}</td>
                            <td>{val.ProductDescription}</td>
                            <td>{val.Narration}</td>
                            {val.CommencementDate !== null &&
                                <td>{formateDateISO(val.CommencementDate)}</td>
                            }
                             {val.CommencementDate == null &&
                                <td></td>
                            }

                             {val.ExpiryDate !== null &&
                                <td>{formateDateISO(val.ExpiryDate)}</td>
                            }
                             {val.ExpiryDate == null &&
                                <td></td>
                            }
                            
                           
                            <td>{formatter(parseInt(val.GrossPremium))}</td>
                            <td>{formatter(parseInt(val.NetCommission))}</td>
                            </tr>
                        );
                        })}
                    </tbody>
                    </Table>

                    {/* Pagination controls */}
                    <div className="d-flex justify-content-between align-items-center">
                    <div>
                        Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, extensions.length)} of {extensions.length} entries
                    </div>
                    <div>
                        <button 
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        >
                        Previous
                        </button>
                        
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <button
                            key={page}
                            className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setCurrentPage(page)}
                        >
                            {page}
                        </button>
                        ))}
                        
                        <button 
                        className="btn btn-sm btn-outline-primary mx-1"
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        >
                        Next
                        </button>
                    </div>
                    </div>
                    </div>
                    
                </CardBody>
            </Card>
         </div>
    </div>
  )
}
